const STEPS = [
  {
    num: "01",
    title: "SEE",
    color: "text-nes-gold",
    blurb:
      "Gets a raw screenshot of the emulator. That's ALL it gets — same view as a human player.",
  },
  {
    num: "02",
    title: "THINK",
    color: "text-nes-blue",
    blurb:
      "Reads the frame like a speedrunner: where's Mario, what's ahead, how many frames to the pit.",
  },
  {
    num: "03",
    title: "PRESS",
    color: "text-nes-green",
    blurb:
      "Holds real NES buttons for an exact frame count — [right+B] to sprint, frame-counted [A] for jumps.",
  },
  {
    num: "04",
    title: "REWIND",
    color: "text-nes-red",
    blurb:
      "Save-states before danger. Dies anyway? Loads the state and retries with better timing. TAS rules.",
  },
];

export function HeroExplainer() {
  return (
    <div className="nes-panel p-4 pt-6">
      <span className="nes-panel-header">WHAT IS THIS?</span>
      <div className="flex flex-col gap-4">
        <p className="font-pixel text-sm text-nes-white leading-relaxed">
          A TOOL-ASSISTED SPEEDRUN, PLAYED BY AN AI THAT CAN ONLY SEE THE
          SCREEN.
        </p>
        <p className="text-[11px] font-mono text-nes-gray leading-relaxed">
          NESTAS hands Claude an NES controller and a screenshot. No memory
          reading, no hitboxes, no cheats — it looks at the pixels, decides
          which buttons to hold and for exactly how many frames, presses them,
          and studies the next screenshot to see what actually happened. Then it
          does it again, frame batch by frame batch, narrating its reasoning the
          whole way.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
          {STEPS.map((step) => (
            <div
              key={step.num}
              className="border-2 border-nes-border bg-[#141414] p-3 flex flex-col gap-2"
            >
              <span className={`font-pixel text-[10px] ${step.color}`}>
                {step.num} {step.title}
              </span>
              <span className="text-[11px] font-mono text-nes-gray leading-relaxed">
                {step.blurb}
              </span>
            </div>
          ))}
        </div>
        <p className="text-[11px] font-mono text-nes-white">
          Paste your own Anthropic API key to run it live — or hit{" "}
          <span className="text-nes-gold">WATCH DEMO</span> for a free recorded
          run.
        </p>
      </div>
    </div>
  );
}
